import React, { useEffect, useState } from 'react';
import { ButtonUI, DialogUI } from '../../Interface';
import { Box } from '@mui/material';
import OpWidgetGroupTable from './OpWidgetGroupTable';

const OpWidgetGrouppedQuantityDialog = ({ open, handleClose, data, handleFinishOperation, autoCompleteOptions }) => {
  const defValues = {
    quantity: '',
    scrapQuantity: '',
    scrapReasonId: null,
  };
  const [values, setValues] = useState(defValues);

  useEffect(() => {
    if (!open) {
      setValues(defValues);
    }
  }, [open]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Mennyiségek megadása"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1500px',
          },
        },
      }}
    >
      <Box mt="1.5rem" gap="1rem">
        <OpWidgetGroupTable
          data={data}
          mode="quantityMode"
          valuesState={{ values, setValues }}
          autoCompleteOptions={autoCompleteOptions}
        />
      </Box>
      <Box textAlign="center" mt="2rem">
        <ButtonUI text="Rögzítés" className="bg-success" onClick={() => handleFinishOperation(values)} />
      </Box>
    </DialogUI>
  );
};

export default OpWidgetGrouppedQuantityDialog;
